export const meta = () => {
	return [{ title: 'Volunteer | EBHS' }]
}

export default function Volunteer() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Volunteering
					</h2>
				</div>
			</header>
			<div className="pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<p className="p-3">
						Be a part of living history! Our doors are always open to community
						friends interested in donating their time and talent to our mission.
					</p>
					<p className="p-3">
						We offer a range of volunteer opportunities accompanied by personal
						instruction to make your experience enjoyable and satisfying.
					</p>
					<p className="p-3">
						Call 585-657-7244 to learn more on the ways you can help.
					</p>
					<p className="p-3">Some of our volunteer areas include:</p>
					<ul className="list-disc pb-3 pl-10">
						<li>Genealogy research</li>
						<li>Educational programs for students and adults</li>
						<li>Event hospitality</li>
						<li>Website administration</li>
						<li>Creation of digital records</li>
						<li>Fundraising events and membership drives</li>
						<li>Building and grounds maintenance</li>
					</ul>

					<img
						src="/images/ebhs/volunteering.png"
						alt="Volunteers helping with a chicken barbecue"
					/>

					<ul className="mt-8 rounded-md border border-gray-200 bg-white">
						<li className="flex items-center justify-between py-3 pl-3 pr-4 text-xl leading-5">
							<div className="flex w-0 flex-1 items-center">
								<span className="ml-2 w-0 flex-1 truncate">
									<a
										href="https://ebhs1838.s3.amazonaws.com/Volunteer%20Form.pdf"
										className="font-medium leading-normal text-blue-700 transition duration-150 ease-in-out hover:text-blue-500"
									>
										Sign up to Volunteer
									</a>
								</span>
							</div>
						</li>
					</ul>
					<br />
					<br />

					<img
						src="/images/ebhs/volunteering/pitch-putt-registration.png"
						alt="Dianne registers a contestant"
					/>
					<span>Dianne registers a contestant</span>
					<br />
					<br />
					<img
						src="/images/ebhs/volunteering/pitch-putt-winner.png"
						alt="With his son Cooper watching, Fred's pitch goes in the hole!! Winner!"
					/>
					<span>
						With his son Cooper watching, Fred&apos;s pitch goes in the hole!!
						Winner!
					</span>
				</div>
			</div>
		</>
	)
}
